export function formatNoDataMessage(items, suffix = 'no data.') {
  if(!items || items.length === 0) {
    return '';
  }

  const names = items.map((item) => (typeof item === 'string' ? item : item?.name)).filter(Boolean);
  const count = names.length;

  if(count === 0) {
    return '';
  }

  let labelText = '';
  if (count === 1) {
    labelText = names[0];
  } else if(count === 2) {
    labelText = `${names[0]} and ${names[1]}`;
  } else {
    labelText = `${names.slice(0, -1).join(', ')}, and ${names[count - 1]}`;
  }

  const verb = count === 1 ? 'has' : 'have';

  return `${labelText} ${verb} ${suffix}`;
}